export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    <div className="flex flex-wrap items-center gap-2">{children}</div>
  </div>
);

export const Card = ({ className = "", children, ...rest }) => (
  <div className={`rounded-xl border border-slate-200/80 bg-white shadow-sm ${className}`} {...rest}>{children}</div>
);

export const StatCard = ({ label, value, icon: I, tone = "emerald", testid, hint }) => {
  const tones = {
    emerald: "bg-emerald-50 text-emerald-600", amber: "bg-amber-50 text-amber-600",
    rose: "bg-rose-50 text-rose-600", blue: "bg-blue-50 text-blue-600", violet: "bg-violet-50 text-violet-600",
  };
  return (
    <Card className="p-5 transition-colors hover:border-slate-300">
      <div className="flex items-start justify-between">
        <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</div>
        {I && <div className={`rounded-lg p-2 ${tones[tone]}`}><I className="h-4 w-4" /></div>}
      </div>
      <div className="mt-3 text-2xl font-bold tracking-tight font-mono" data-testid={testid}>{value}</div>
      {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
    </Card>
  );
};
